import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector } from '@mui/x-data-grid';

/** Shared DataGrid toolbar: column chooser + density selector. Search/filter/export stay
 * page-specific since they're already real, server-backed controls — duplicating them via
 * DataGrid's own (client-side-only) toolbar widgets would only cover the current page of rows. */
export const TableToolbar = () => (
  <GridToolbarContainer sx={{ px: 1.5, py: 1, justifyContent: 'flex-end', gap: 0.5 }}>
    <GridToolbarColumnsButton />
    <GridToolbarDensitySelector />
  </GridToolbarContainer>
);
